import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { LoaderIcon } from '../../index';

interface IContentLoaderProps {
	isLoading: boolean;
	hasPortal?: boolean;
	height?: string;
}

const renderContentLoader = (portal: boolean, height: string) => (
	<div
		className={`${
			portal ? 'fixed top-0 left-0 h-full' : `${height}`
		} w-full z-[3000] bg-white/[0.40] flex items-center justify-center`}>
		<span className="inline-flex animate-spin">
			<LoaderIcon size="52" />
		</span>
	</div>
);

export const ContentLoader = ({ isLoading, hasPortal = true, height = 'h-[50vh]' }: IContentLoaderProps) => {
	useEffect(() => {
		if (isLoading) {
			document.body.style.overflow = 'hidden';
		}
		return () => {
			document.body.style.overflow = '';
		};
	}, [isLoading]);
	if (isLoading)
		return hasPortal
			? createPortal(renderContentLoader(hasPortal, height), document.getElementById('portal') as HTMLElement)
			: renderContentLoader(hasPortal, height);
	return <></>;
};
